import { RecentlyViewed } from '@theme/recently-viewed-products';

class RecentlyViewedComponent extends HTMLElement {
  #rendered = false;

  async connectedCallback() {
    if (this.#rendered) return;
    this.#rendered = true;

    const sectionId = this.getAttribute('section-id');
    const selector = this.getAttribute('selector');
    if (!sectionId) return;

    if (RecentlyViewed.getProducts().length === 0) {
      this.style.display = 'none';
      return;
    }

    const html = await RecentlyViewed.renderProducts(sectionId);
    if (!html) {
      this.style.display = 'none';
      return;
    }

    if (selector) {
      const target = this.querySelector(selector);
      if (!target) return;
      target.innerHTML = html;
    } else {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const freshContent = doc.querySelector('[data-recently-viewed]');
      if (!freshContent) return;
      this.replaceChildren(...freshContent.childNodes);
    }
  }
}

customElements.define('recently-viewed', RecentlyViewedComponent);
